<template>
  <div>
    <span>亲爱的开发者：<br />首先非常感谢您选择并使用美团地图开放平台上所提供的产品或服务！<br /></span>
    <span>
      国家网信办等四部委在2019年5月联合发布了《关于开展App违法违规收集使用个人信息专项治理的公告》(以下简称《公告》)。为落实《公告》相关部署，受四部门委托，全国信息安全标准化技术委员会、中国消费者协会、中国互联网协会、中国网络空间安全协会成立App违法违规收集使用个人信息专项治理工作组(以下简称“App专项治理工作组”)，具体推动App违法违规收集使用个人信息评估工作。在2019年11月28日，App专项治理工作组印发了<a
         href="http://www.cac.gov.cn/2019-12/27/c_1578986455686625.htm"
         class="ct-link"
         target="_blank"
         rel="noopener">《App违法违规收集使用个人信息行为认定方法》</a>（国信办秘字〔2019〕191号）。2020年7月，全国信息安全标准化技术委员会秘书处发布了<u><a href="https://www.tc260.org.cn/front/postDetail.html?id=20200722134829"
           class="ct-link"
           target="_blank"
           rel="noopener">《网络安全标准实践指南—移动互联网应用程序（App）收集使用个人信息自评估指南》</a></u>（以下简称为“指南”），您可参照该指南对其收集使用个人信息的情况进行自查自纠，提升个人信息保护水平。
    </span>
    <span>
      美团地图开放平台非常重视用户个人信息保护，包括使用集成美团地图开放平台SDK/API产品或服务的最终用户（以下简称“最终用户”）的个人信息保护，特别为了帮助使用本开放平台的SDK/API的App开发者和运营者（以下简称“您”）在您所开发的产品（以下简称“您的产品”）中更好地落实前述所列的相关法律法规、政策及标准中的合规要求，同时，也便于您更清楚地理解、认识美团所提供的SDK产品与API能力的合规性和已采用的安全保护技术能力，尤其是保护个人信息和隐私的方法和措施，我们特编写《美团地图开发者合规指南》（以下简称“《指南》”），供您参考。由于目前相关法律法规、政策及标准中主要对SDK产品的应用提供相关指引，以下将统一以SDK视角描述相关内容，如您是集成、调用美团地图API能力的开发者和运营者，本《指南》中适用于美团API能力的部分同样可供您参考。<br /><br /><strong>一、&nbsp;&nbsp;个人信息保护合规基本要求</strong><br /><br />在您的产品中集成并使用美团SDK，请您首先遵守以下个人信息保护合规基本要求：<br /><br />
      <span>1.您应遵守收集、使用最终用户个人信息有关的所有可适用法律法规及规范性文件要求保护用户个人信息安全，包括但不限于<u><a href="http://www.npc.gov.cn/wxzl/gongbao/2017-02/20/content_2007531.htm"
             class="ct-link"
             target="_blank"
             rel="noopener">《网络安全法》</a></u>、<u><a href="http://www.cac.gov.cn/2019-12/27/c_1578986455686625.htm"
             class="ct-link"
             target="_blank"
             rel="noopener">《App违法违规收集使用个人信息行为认定方法》</a></u>、<u><a href="http://www.npc.gov.cn/wxzl/gongbao/2014-01/02/content_1823351.htm"
             class="ct-link"
             target="_blank"
             rel="noopener">《消费者权益保护法》</a></u>、<u><a
             href="https://mapopen-website-wiki.bj.bcebos.com/data/%E4%BF%A1%E6%81%AF%E5%AE%89%E5%85%A8%E6%8A%80%E6%9C%AF_%E4%B8%AA%E4%BA%BA%E4%BF%A1%E6%81%AF%E5%AE%89%E5%85%A8%E8%A7%84%E8%8C%83.pdf"
             class="ct-link"
             target="_blank"
             rel="noopener">《信息安全技术 个人信息安全规范》</a></u>等<u><a href="http://www.gov.cn/xinwen/2019-11/07/content_5449660.htm"
             class="ct-link"
             target="_blank"
             rel="noopener">《工业和信息化部关于开展APP侵害用户权益专项整治工作的通知》</a></u>、<u><a href="http://www.cac.gov.cn/2020-07/28/c_1597492913060262.htm"
             class="ct-link"
             target="_blank"
             rel="noopener">《工业和信息化部关于开展纵深推进APP侵害用户权益专项整治行动的通知》</a></u>等。
      </span>
    </span>
    <br /> 2.您应确保您所开发或运营的App有《隐私政策》，并且在App用户首次运行时通过弹窗等明显的方式提示用户阅读隐私政策供用户确认。<br /><br />3.您应将在您的产品中集成并使用美团地图SDK的情况，以及美团地图SDK对最终用户必要个人信息的收集、使用和保护规则（例如<span style="color: rgb(0, 0, 0)">
      <a href="https://rules-center.meituan.com/rules-detail/2"
         class="ct-link"
         target="_blank"
         rel="noopener">《美团隐私政策》</a></span><span
          style="color: ">等</span>），以明显的方式方式告知最终用户（具体可参看第二部分中的如何进行告知的示范文案），并获得最终用户的授权同意。如果最终用户是未满14周岁的未成年人，请您务必确保获得最终用户的父母或其他监护人对于最终用户使用您的产品期间美团SDK收集、使用最终用户相关个人信息的完整、合法、持续有效的授权同意。<br /><br />3.您应向最终用户提供易于操作的访问、更正、删除其个人信息，撤销或更改其授权同意、注销其个人账号等用户权利实现机制。<br /><br />4.您应确保在您的产品首次运行时，应在最终用户阅读并同意您的产品的隐私政策之后，方可调用美团SDK服务。<br /><br />除了上述个人信息保护合规基本要求外，您<span
          style="color: rgb(0, 0, 0)">还应遵守<a href="https://rules-center.meituan.com/rules-detail/2"
         class="ct-link"
         target="_blank"
         rel="noopener">《美团隐私政策》</a>、<a href="https://rules-center.meituan.com/rules-detail/4"
         class="ct-link"
         target="_blank"
         rel="noopener">《美团用户协议》</a>等规则</span>。<br /><br /><strong>二、&nbsp;&nbsp;如何进行告知的示范文案</strong><br /><br />为帮助您明确地告知最终用户美团SDK个人信息保护规则相关事宜，我们为您提供了以下告知文案示例供您参考执行：<br /><br /><strong><u>文案示范：</u></strong><br /><span
          style="color: ">为保障</span>【产品名称】<span
          style="color: ">App相关功能的实现与应用的稳定运行，我们可能会接入由第三方提供的软件开发包（SDK）以实现相关目的。不同版本的第三方SDK会有所不同，一般包括推送通知消息类、地图导航类、分享类等。我们会对合作方获取信息的软件工具开发包（SDK）进行严格的安全监测，以保障数据安全。您可以通过以下链接查看第三方的数据使用和保护规则。</span>
    <div class="table-wrapper">
      <table style="width: 876px">
        <thead>
          <tr class="originHeader">
            <th width="115px">
              <p><strong>功能类型</strong></p>
            </th>
            <th width="150px">
              <p><strong>使用目的</strong></p>
            </th>
            <th width="120px">
              <p><strong>第三方名称</strong></p>
            </th>
            <th width="120px">
              <p><strong>涉及个人信息</strong></p>
            </th>
            <th width="396px">
              <p><strong>第三方官网链接</strong></p>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td width="99px">
              <p>【功能描述】</p>
            </td>
            <td width="163px">
              <p>【目的或用途描述】</p>
            </td>
            <td width="129px">
              <p>【产品名称】</p>
            </td>
            <td width="99px">
              <p>【产品名称】</p>
            </td>
            <td width="396px">
              <span>官网链接：【第三方官网链接】</span>
              <br /><br />隐私政策链接：【第三方隐私政策的官网链接】<u><span style="color: "><a href="https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&amp;t=weixin_agreement&amp;s=privacy"
                     class="ct-link"
                     target="_blank"
                     rel="noopener"></a></span></u>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <p style="text-align: start">
      <strong>四、&nbsp;&nbsp;美团的数据安全保护能力</strong>
    </p>
    <span>我们非常重视用户以及开发者的数据安全以及个人信息的保护，并在数据生命周期的各个不同阶段都建立了数据安全保护机制，并根据法律法规的要求采取想要的措施来进行保障。
    </span>
    <span>美团的主要系统<span style="color: rgba(0, 0, 0, 0.87)">公安部信息系统安全三级等保认证</span>，并且美团还获得了<span style="color: rgba(0, 0, 0, 0.87)">ISO/IEC27001:2013信息安全管理体系</span>认证。
    </span>
    <span><span style="color: ">感谢您阅读美团地图开放平台开发者合规指引，并欢迎您给我们提出建议！如有任何疑问，也请随时</span>与我们联系<span style="color: ">！</span>
    </span>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="less" >
.ct-link {
  color: #1890ff;
}
p {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.72);
  line-height: 24px;
  text-align: justify;
  font-weight: 400;
  margin-top: 6px;
  margin-bottom: 0;
}

.table-wrapper {
  margin-top: 12px;
  border-radius: 4px;
  width: 876px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  overflow: hidden;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
  margin: -1px;
  width: 876px;
  text-align: left;
  thead {
    background: #f5f5f7;
    color: rgba(0, 0, 0, 0.72);
    font-weight: 600;
    th {
      padding: 6px 12px;
      border: 1px solid rgba(0, 0, 0, 0.12);
    }
  }
  td {
    padding: 6px 12px;
    border: 1px solid rgba(0, 0, 0, 0.12);
  }
}
</style>
